import React from 'react'
import {
  GridColumn as Column,
  Grid,
  GridCellProps,
  GridColumnProps,
  GridDetailRowProps,
} from '@progress/kendo-react-grid'
import { TradingAccountActivityPerGroupingDtoKey } from 'api/Trading-Accounts/Types/TradingAccountActivityPerGroupingDto'
import { WelcomeAccountIpActivityDto } from 'api/Trading-Accounts/Types/WelcomeAccountIpActivityDto'
import { dateComparator, formatLocalDateUTC } from 'utils/date'

interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const detailColumns: GridColumn[] = [
  {
    title: 'Date from',
    field: TradingAccountActivityPerGroupingDtoKey.dateFrom,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.dateFrom) {
        return <td />
      }
      return (
        <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem.dateFrom, true)}</td>
      )
    },
    className: 'table-columns__date',
    show: true,
  },
  {
    title: 'Date to',
    field: TradingAccountActivityPerGroupingDtoKey.dateTo,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.dateTo) {
        return <td />
      }
      return (
        <td className='table-columns__date'>{formatLocalDateUTC(props.dataItem.dateTo, true)}</td>
      )
    },
    className: 'table-columns__date',
    show: true,
  },
  {
    title: 'Login',
    field: TradingAccountActivityPerGroupingDtoKey.login,
    className: 'table-columns__content',
    show: true,
  },
  {
    title: 'Count',
    field: TradingAccountActivityPerGroupingDtoKey.count,
    className: 'table-columns__number',
    show: true,
  },
]

export const WelcomeAccountsDetailTable: React.FC<GridDetailRowProps> = (props) => {
  const dataItem: WelcomeAccountIpActivityDto = props.dataItem

  return (
    <Grid
      resizable
      data={[...dataItem.welcomeAccounts].sort((a, b) => dateComparator(a.dateFrom, b.dateFrom))}
      total={dataItem.welcomeAccounts.length}
    >
      {detailColumns
        .filter((c) => c.show !== false)
        .map((column, idx) => (
          <Column key={idx + 2} {...column} />
        ))}
    </Grid>
  )
}
